<h3>Radarbericht</h3>
<p>
  Das Regenradar zeigt die Niederschlagsmenge. Gemessen wird sie mit Hilfe eines Radarechos. Je stärker das Signal von
  Wolken und Regentropfen zurück an die Sendestation reflektiert wird, desto stärker ist der Niederschlag. Die Farben
  kennzeichnen die Stärke.

  Die Radardaten werden vom Deutschen Wetterdienst zur Verfügung gestellt. Aufgrund von Wartungsarbeiten an den
  Radarstationen oder technischen Störungen kann es vorkommen, dass eine oder mehrere Stationen zeitweise keine Daten
  senden. Die abgedunkelten Flächen markieren die Gebiete, für die keine Radardaten vorliegen.

  In Südhessen ist im Radarbild häufiger eine Art Dreieck ohne bzw. mit schlechter Radarabdeckung zu sehen. Ursache sind
  die für dieses Gebiet ungünstigen Standorte der DWD-Radarstationen. Das betroffene Gebiet ist im Westen von der Linie
  Bensheim / Darmstadt, im Norden von der Linie Erzhausen / Aschaffenburg und im Süden von der Linie Bensheim / Breuberg
  / Heimbuchenthal begrenzt.
</p>
